"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.describeBranchCircuit = exports.formatBranchCircuitLabel = exports.BreakerType = void 0;
var BreakerType;
(function (BreakerType) {
    BreakerType["AMP_15"] = "amp15";
    BreakerType["AMP_20"] = "amp20";
    BreakerType["AMP_30"] = "amp30";
    BreakerType["AMP_40"] = "amp40";
    BreakerType["AMP_70"] = "amp70";
})(BreakerType = exports.BreakerType || (exports.BreakerType = {}));
/**
 * The installer's name for a circuit — "Pool", "Garage — Freezer".
 *
 * There is no dedicated label field on `BranchCircuit`; `location` /
 * `sublocation` are what installers actually fill in, so they are the name.
 * Returns `undefined` when neither was set, so callers can fall back to the
 * circuit number instead of rendering an empty string.
 */
const formatBranchCircuitLabel = (circuit) => {
    const label = [circuit.location, circuit.sublocation]
        .map((part) => part?.trim())
        .filter((part) => !!part)
        .join(' — ');
    return label || undefined;
};
exports.formatBranchCircuitLabel = formatBranchCircuitLabel;
/**
 * How a circuit should be named in an alert or on a card. Leads with the
 * installer's label and keeps the circuit number in parentheses: the name is
 * what a homeowner understands, the number is what a tech reads off the panel,
 * and dropping either one forces somebody to go guess at the box.
 *
 * Unlabelled circuits keep the old bare-number wording.
 */
const describeBranchCircuit = (circuit) => {
    const label = (0, exports.formatBranchCircuitLabel)(circuit);
    return label
        ? `${label} (circuit ${circuit.circuitNumber})`
        : `Branch circuit ${circuit.circuitNumber}`;
};
exports.describeBranchCircuit = describeBranchCircuit;
